import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getProjects,
  deleteProject,
  getNextProjects,
  getPreviousProjects,
} from "../../store/actions/projects_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/projects_enum";
import DataTable from "../../components/common/DataTable";
const AllProjects = ({
  getProjects,
  deleteProject,
  getNextProjects,
  getPreviousProjects,
  project: { loading, projects },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteProject(deleteEntry);
      }
      getProjects({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (projects && projects.length === LIMIT) {
      const lastProject = projects[projects.length - 1];
      getNextProjects({ last: lastProject });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastProject = projects[0];
      getPreviousProjects({
        first: lastProject,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getProjects({ term: term, termField: termField });
    }
  };
  const deleteProjectClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getProjects({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Projects"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Project"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="projects" title="Project" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={projects}
                      field={"projects"}
                      page={page}
                      deleteBtnClicked={deleteProjectClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={projects}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ project: state.project });

const mapDispatchToProps = {
  getProjects,
  deleteProject,
  getNextProjects,
  getPreviousProjects,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllProjects);
